<template>
<div class="wrapper">
  <div class="top-box">
    <div class="top-video">
      <video class="pc" src="@/assets/top-pc.mp4" autoplay muted loop></video>
      <video class="sp" src="@/assets/top-sp.mp4" autoplay  muted loop playsinline></video>
    </div>
    <div class="top-message-box">
      <h1 class="top-message">世界一安全に、<br class="pc-br">大型輸送をする会社</h1>
      <h2 class="top-message-caption">Moving BOX with SAFETY</h2>
      <div class="resizeimage">
        <a href="https://job.mynavi.jp/22/pc/search/corp112528/outline.html" target="_blank">
          <img alt="マイナビ" src="../assets/mynavi.png">
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid hot-topic">
    <div class="row topic-row">
      <div class="col-md-4 col-lg-4 col-xs-12 hot-topic-text">
        -お知らせ-<br>
        新型コロナウイルス感染症への対応について
      </div>
      <div class="col-md-8 col-lg-8 col-xs-12">
        当社では感染症対策として、観光バス全車両への除菌機器の設置、ならびに新たな清掃・除菌プログラムの導入を行いました。<br>
        詳しくはページ下部をご確認ください。
      </div>
    </div>
  </div>
  <div class="container banner">
    <div class="row banner-row">
      <router-link class="col-md-4 col-lg-4 col-xs-12 bus-banner" to="/bus">
        <div class="box1" to="/bus">
          <p>BUS</p>
        </div>
        <div class="box2">
          <p>貸切バスのご案内</p>
        </div>
      </router-link>
      <router-link class="col-md-4 col-lg-4 col-xs-12 cargo-banner" to="/cargo">
        <div class="box1">
          <p>CARGO</p>
        </div>
        <div class="box2">
          <p>貨物のご案内</p>
        </div>
      </router-link>
      <router-link class="col-md-4 col-lg-4 col-xs-12 const-banner" to="/construction">
        <div class="box1 box1-const">
          <p>CONSTRUCTION</p>
        </div>
        <div class="box2">
          <p>工事のご案内</p>
        </div>
      </router-link>
    </div>
  </div>
  <div class="container-fluid corona">
    <div class="corona-message">
      <div class="title-box">
        <h1 class="title">東栄観光バスの感染症対策</h1>
        <h2 class="caption">弊社では新型コロナウイルス感染症対策の取り組みとして<br>下記8つの事項を実施しております。</h2>
        <a href="https://toei.myweb.co.jp/bus/東栄観光バスの感染症予防対策.pdf" class="box4">
          <p>資料のダウンロード</p>
          <div class="arrow01"></div>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid measures">
    <div class="row">
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/01_外気取り入れ.png"/>
        <div class="box">
          <p>車内の空気を5分で総入れ替え<br>エアコン外気導入モード</p>
        </div>
      </div>
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/10_ワクチン接種.png"/>
        <div class="box">
          <p>運転士のワクチン接種率<br><strong>2回目接種 88.6％</strong>(予定含む)<br>8/5現在</p>
        </div>
      </div>
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/03_パネル設置.png"/>
        <div class="box">
          <p>運転士とお客様を隔てる<br>透明パネル・カーテンの設置</p>
        </div>
      </div>
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/04_空気清浄機.png"/>
        <div class="box">
          <p>最新式プラズマクラスタータイプ<br>空気清浄機の設置</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/05_アルコール除菌.png"/>
        <div class="box">
          <p>アルコール除菌液の設置</p>
        </div>
      </div>
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/09_抗菌コーティング.png"/>
        <div class="box">
          <p>約99％ウイルス除去効果あり<br>抗菌コーティングを全車両実施</p>
        </div>
      </div>
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/02_マスク着用.png"/>
        <div class="box">
          <p>乗務員のマスク着用<br>お客様にマスク着用のお願い</p>
        </div>
      </div>
      <div class="icon col-md-3 col-lg-3 col-sm-6 col-xs-12">
        <img src="@/assets/06_窓開閉.png"/>
        <div class="box">
          <p>お客様に走行中の窓開閉<br>ご協力のお願い</p>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid feature">
    <div class="row">
      <div class="image-content">
        <span class="title-box">
          <h1 class="title">創業50年<br>業界最高の安全品質</h1>
        </span>
        <div class="box3">
          <p>当社は安全・安心を第一に<br>お客さまやお荷物を目的地にお届けします。<br>創業50年。<br>2つの認定が、安全性の高さの証明です。</p>
          <router-link class="box4" to="/safety">
            <p>当社の安全への取り組み</p>
            <div class="arrow01"></div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <div class="table-container">
    <div class="table-title">News</div>
    <div class="table">
        <div class="row" v-for="(item, index) in items" :key=index>
          <div class="row-heading">
            <div class="date">{{ item.date }}</div>
            <div class="department">{{ item.department }}</div>
          </div>
          <div class="col-lg-10 col-m-10 col-sm-10 col-12 content" v-if="item.url">
            <a v-bind:href="item.url" target="_blank">{{ item.content }}</a>
          </div>
          <div class="col-lg-10 col-m-10 col-sm-10 col-12 content" v-else>
            <a >{{ item.content }}</a>
          </div>
        </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      items: []
    }
  },
  created () {
    axios
      .get('https://script.google.com/macros/s/AKfycbzLbrMLbgO1esSEvc0ckfTlYMODegABBSXe0qhHOE1iwd-Ti6u2/exec', { crossDomain: true })
      .then(response => (this.items = response.data))
  }
}
</script>

<style scoped>
.wrapper {
  overflow: hidden;
}
.top-box {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
video {
  width: 100%;
  height: 100%;
  z-index: 1;
}
.pc {
  display: block !important;
}
.sp {
  display: none !important;
}
@media only screen and (max-width:480px) {
  .pc {
    display: none !important;
  }
  .sp {
    display: block !important;
  }
}
@media only screen and (min-width:540px) and (orientation:portrait) {
  .pc {
    display: none !important;
  }
  .sp {
    display: block !important;
  }
}
.top-message-box {
  position: absolute;
  top: 37%;
  bottom: 0;
  right: 0;
  left: 0;
}
.top-message {
  font-size: 36px;
  text-align: center;
  font-weight: bold;
  color: #FFFFFF;
  width: 100%;
}
.top-message-caption {
  font-size: 20px;
  text-align: center;
  font-weight: bold;
  color: #FFFFFF;
  width: 100%;
}
.resizeimage {
  max-width: 439px;
  min-width: 230px;
  padding-left: 88px;
  padding-right: 88px;
  padding-top: 22px;
  margin: 0 auto;
}
.resizeimage img {
  width: 100%;
}
.resizeimage-banner {
  max-width: 400px;
  min-width: 230px;
  position: absolute;
  bottom: 48px;
  right: 10%;
}
.resizeimage-banner img {
  width: 100%;
}
.mynavi {
  margin-top: 45px;
}
.hot-topic {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFF0F9 0% 0% no-repeat padding-box;
  height: auto;
  font-size: 12px;
  color: #000000;
}
.topic-row {
  width: 100%;
  padding-top: 49px;
  padding-bottom: 49px;
  padding-left: 50px;
  padding-right: 50px;
}
.hot-topic-text {
  display: flex;
  align-items: center;
}
.banner {
  padding-right: 50px;
  padding-left: 50px;
}
.banner-row {
  margin-bottom: 21px;
  margin-top: 21px;
  display: flex;
  justify-content: space-around;
}
.bus-banner {
  background-image: url("../assets/bus-banner.png");
  background-repeat: no-repeat;
  background-size:  cover;
  background-position-x: 69%;
  margin-top: 21px;
  margin-bottom: 21px;
  max-width: 340px;
}
.cargo-banner {
  background-image: url("../assets/cargo-banner.png");
  background-repeat: no-repeat;
  background-size:  cover;
  margin-top: 21px;
  margin-bottom: 21px;
  max-width: 340px;
}
.const-banner {
  background-image: url("../assets/construction-banner.png");
  background-repeat: no-repeat;
  background-size:  cover;
  margin-top: 21px;
  margin-bottom: 21px;
  max-width: 340px;
}
.box1 {
  padding: 0.5em 1em;
  margin: 15px 13px;
  font-weight: bold;
  border: solid 3px #FFFFFF;
  min-height: 124px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.box1 p {
  font-size: 38px;
  color: #FFFFFF;
  margin: 0;
  padding: 0;
}
.box1-const p {
  font-size: 25px!important;
}
.box2 {
  box-shadow: 2px 2px 4px gray;
  position: absolute;
  padding: 5px 14px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: -23px;
  min-width: 170px;
  text-align: center;
}
.box2 p {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.box3 {
  position: absolute;
  padding: 5px 14px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  text-align: left;
  opacity: 0.6;
}
.box3 p {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.box4 {
  border: 2px solid #7E7474;
  padding: 5px 14px;
  margin-top: 20px;
  margin-bottom: 11px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  right: 9px;
  bottom: 27px;
  min-width: 170px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box4 p {
  font-size: 20px!important;
  font-weight: 600;
  color: #000000;
  margin: 0;
  padding: 0;
}
.arrow01 {
  display: block;
  width: 12px;
  height: 12px;
  border-top: solid 3px #7E7474;
  border-right: solid 3px #7E7474;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  position: absolute;
  right: 10%;
}
.corona-message {
  position: relative;
}
.corona-message .title-box {
  position: absolute;
  top: 229px;
  left: 50%;
  padding: 0;
  display: block;
}
.corona-message .title {
  font-size: 21px;
  font-weight: 700;
  letter-spacing: 0;
  color: #3B4043;
  line-height: 35px;
  text-align: center;
}
.corona-message .caption {
  font-size: 16px;
  text-align: center;
  font-weight: bold;
}
.measures {
  padding: 60px;
}
.measures img {
  max-width: 148px;
}
.measures .icon {
  text-align: center;
}
.measures .box {
  padding: 7px 14px;
  text-align: center;
  font-size: 14px;
  color: #3B4043;
}
.title-box {
  display: inline-flex;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 60px;
}
.title {
  top: 106px;
  left: 64px;
  font-size: 21px;
  font-weight: 700;
  letter-spacing: 0;
  color: #FFFFFF;
  line-height: 35px;
}
.corona {
  background: url("../assets/top-bus-corona.png");
  background-color: #FFF0F9;
  background-repeat: no-repeat;
  background-size: 63%;
  background-position: left;
  min-height: 414px;
}
.feature {
  background: url("../assets/top-bus.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
.image-content {
  min-height: 800px;
  position: relative;
  width: 100%;
}
.table-container {
  padding: 50px;
}
.table-title {
  color: #6F6B6B;
  padding-bottom: 22px;
}
.table {
  font-size: 13px;
}
.table .row {
  border-top: 1px solid #dee2e6;
  padding: .75rem;
  vertical-align: top;
}
.row-heading {
  min-width: 128px;
  display: flex;
  justify-content: space-between;
}
.table .date {
  font-weight: bold;
}
.table .department {
  min-width: 52px;
}
.table .content {
  padding-left: 0px;
}
@media screen and (min-width:800px) {
  .corona-message .title {
    font-size: 34px;
    font-weight: 700;
    letter-spacing: 0;
    color: #3B4043;
    line-height: 55px;
    text-align: center;
  }
  .title {
    top: 106px;
    left: 64px;
    font-size: 44px;
    font-weight: 700;
    letter-spacing: 0;
    color: #FFFFFF;
    line-height: 55px;
  }
  .box3 p {
    font-size: 17px;
    font-weight: 600;
    color: #000000;
    margin: 0;
    padding: 0;
  }
  .pc-br {
    display: none;
  }
  .top-message {
    font-size: 50px;
  }
}
@media screen and (max-width:600px) {
  .corona {
    background: url("../assets/top-bus-corona.png");
    background-color: #FFF0F9;
    background-repeat: no-repeat;
    background-size: contain;
    min-height: 450px;
  }
  .corona-message .title {
    font-size: 27px;
  }
  .corona-message .caption {
    font-size: 11px;
    text-align: center;
    font-weight: bold;
  }
  .corona-message .title-box {
    top: 300px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .image-content {
    min-height: 603px;
    position: relative;
    width: 100%;
  }
  .feature {
    background: url("../assets/top-bus.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 20%;
  }
  .resizeimage-banner {
    max-width: 439px;
    min-width: 230px;
    position: absolute;
    bottom: 48px;
    left: 172px;
  }
  .resizeimage-banner img {
    width: 100%;
  }
  .topic-row {
    padding-left: 0px;
    padding-right: 0px;
  }
  .hot-topic-text {
    padding-bottom: 24px;
  }
  .box2 p {
    font-size: 16px;
  }
  .table .content {
    padding-top: .75rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue